<template>
  <InLifeFooter
    v-if="hasFeature && hasLeases && isMobile"
    :routes="routes"
    :create-options="createOptions"
    @create="createAction"
  />
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import getUserFeatures from '@/utils/user-features';
import { profileCompleteGuard } from '@/utils/profile-complete-guard';
import { getEnv } from 'ecx.saigon.ui.common';

export default {
  name: 'InLifeFooterWidget',
  computed: {
    ...mapState({
      hasLeases: (state) => state.lease.hasLeases
    }),
    ...mapGetters(['canCreateQuote']),
    hasFeature() {
      return getUserFeatures()[this.$Constants.FEATURES.inLife];
    },
    isMobile() {
      return this.$q.screen.xs;
    },
    help() {
      return this.$Constants.IN_LIFE_FOOTER_HELP;
    },
    createOptions() {
      let options = [];
      if (this.hasLeases) {
        options.push({
          ...this.$Constants.IN_LIFE_CREATE_OPTIONS.CLAIM,
          active: this.$route.matched.some(
            (route) => route.name === this.$RouteNames.claimsNew
          )
        });
      }
      if (this.canCreateQuote) {
        options.push({
          ...this.$Constants.IN_LIFE_CREATE_OPTIONS.QUOTE,
          active: false
        });
      }
      return options;
    },
    routes() {
      return [
        {
          name: this.$RouteNames.dashboard,
          label: 'HOME',
          icon: 'icon-nav-home',
          disable: false,
          active: this.$route.matched.some(
            (route) => route.name === this.$RouteNames.dashboard
          ),
          to: () => {
            this.$euiNotifications.emit({
              notification: 'FOOTER_ACTION_DASHBOARD'
            });
            if (!this.$route.name !== this.$RouteNames.dashboard) {
              this.$euiNotifications.emit({
                notification: 'FOOTER_TO_DASHBOARD'
              });
              this.$router.push({
                name: this.$RouteNames.dashboard
              });
            }
          }
        },
        {
          name: this.$RouteNames.budgets,
          label: 'BUDGET',
          icon: 'icon-nav-budget',
          disable: false,
          active: this.$route.matched.some(
            (route) => route.name === this.$RouteNames.budgets
          ),
          to: () => {
            this.$euiNotifications.emit({
              notification: 'FOOTER_ACTION_BUDGETS'
            });
            if (this.$route.name !== this.$RouteNames.budgets) {
              this.$euiNotifications.emit({
                notification: 'FOOTER_TO_BUDGETS'
              });
              this.$router.push({
                name: this.$RouteNames.budgets
              });
            }
          }
        },
        {
          name: this.$RouteNames.claims,
          label: 'CLAIMS',
          icon: 'icon-nav-claims',
          disable: false,
          active: this.$route.matched.some(
            (route) => route.name === this.$RouteNames.claimsLanding
          ),
          to: () => {
            this.$euiNotifications.emit({
              notification: 'FOOTER_ACTION_CLAIMS_LANDING'
            });

            const isClaimsLanding =
              this.$route.name === this.$RouteNames.claimsLanding;
            const isClaimsDesktop =
              this.$route.name === this.$RouteNames.claims && !this.isMobile;

            if (!isClaimsLanding && !isClaimsDesktop) {
              this.$euiNotifications.emit({
                notification: 'FOOTER_TO_CLAIMS_LANDING'
              });
              this.$router.push({
                name: this.$RouteNames.claimsLanding
              });
            }
          }
        }
      ];
    }
  },
  methods: {
    async createQuote() {
      const env = await getEnv();
      if (profileCompleteGuard(this)) {
        return (window.location = env.VUE_APP_QUOTE_ROUTE);
      }
    },
    createAction(key) {
      const options = this.$Constants.IN_LIFE_CREATE_OPTIONS;
      switch (key) {
        case options.CLAIM.key:
          if (this.$route.name !== this.$RouteNames.claimsNew) {
            return this.$router.push({
              name: this.$RouteNames.claimsNew
            });
          }
          break;
        case options.QUOTE.key:
          this.createQuote();
          break;
      }
    }
  },
  components: {
    InLifeFooter: () => import('../../components/organism/in-life-footer')
  }
};
</script>
